import React from "react";
import "./MiniLoadingIndicator.css";

type Props = {};

type State = {};

class MiniLoadingIndicatorWrapper extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {};
	}

	componentDidMount() {}

	render() {
		return (
			<div
				className="mini-loading-indicator-wrapper"
				style={{
					display: "flex"
				}}
			>
				<div className="mini-indicator"></div>
			</div>
		);
	}
}

export default MiniLoadingIndicatorWrapper;
